import { useQueryErrorResetBoundary } from '@tanstack/react-query'
import type { ParseKeys } from 'i18next'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { getApiErrorMessage } from '@/utils/errors'

interface RouteErrorFallbackProps {
	error: Error
	reset: () => void
	fallbackMessageKey?: ParseKeys
}

export function RouteErrorFallback({ error, reset, fallbackMessageKey }: RouteErrorFallbackProps) {
	const { t } = useTranslation()
	const { reset: resetQueries } = useQueryErrorResetBoundary()

	function handleReset() {
		resetQueries()
		reset()
	}

	const fallback = fallbackMessageKey ? t(fallbackMessageKey) : t('error.generic')

	return (
		<div className='flex flex-col items-start gap-3'>
			<p className='text-destructive text-sm'>{getApiErrorMessage(error, fallback)}</p>
			<Button variant='outline' size='sm' onClick={handleReset}>
				{t('error.retry')}
			</Button>
		</div>
	)
}
